<kodit-page>
  <kodit-table [tableConfig]="tableConfig" [paginatedData]="paginatedData" [isTableLoading]="isLoading"></kodit-table>
</kodit-page>
